import { Grid } from 'antd';
import theme from 'app/App.theme';
import { useMemo } from 'react';
import { isEmpty } from 'utils';

const _isMobile = window.innerWidth < theme.media.mobile;
const _isTablet = !_isMobile && window.innerWidth < 992;

export default function useMedia() {
  const screens = Grid.useBreakpoint();

  return useMemo(
    () => ({
      isMobile: Boolean(isEmpty(screens) ? _isMobile : screens.xs),
      isTablet: Boolean(isEmpty(screens) ? _isTablet : (screens.sm || screens.md) && !screens.lg),
      screens,
    }),
    [screens],
  );
}
